/**
 * Not found — the answer to a URL that does not belong to this person.
 *
 * Used for two different situations that deliberately look identical:
 *
 *  - a path that matches no route at all;
 *  - a path that exists but belongs to another surface. A student asking for
 *    /admin gets this, not a redirect to /today.
 *
 * Being told "not found" rather than "not allowed" is the point. A redirect
 * silently rewrote the URL the person typed, which read as the app malfunctioning,
 * and a 403-style page would confirm that a console exists at that address for
 * someone else to go looking for. The only thing offered is the way back into the
 * part of the app they do own.
 */
import { Link } from 'react-router-dom';
import { AuthHeading, AuthLayout } from '@/components/auth/AuthLayout';
import { landingPathFor } from '@/lib/auth';
import { useClaims } from '@/hooks/useSession';
import { fontPx } from '@/lib/fontSize';

export function NotFoundPage() {
  const claims = useClaims();
  const home = landingPathFor(claims);

  return (
    <AuthLayout>
      <div className="flex flex-col gap-5">
        <AuthHeading title="Page not found">
          This address doesn’t exist{claims ? ' on your account' : ''}. Check the link, or head back
          to where you were.
        </AuthHeading>
        <Link
          to={home}
          className="font-semibold text-forest underline-offset-2 hover:underline"
          style={{ fontSize: fontPx(14) }}
        >
          Go to {home}
        </Link>
      </div>
    </AuthLayout>
  );
}

export default NotFoundPage;
